// Field — shared form control (PSD §10.3). Presentation.
//
// Stage 16 extension: `helpText` renders an inline "?" tooltip next to the
// label so a sentence of contextual help can be attached to any field without
// wrapping its children. Help text must be inferred from engine source.

import type { ReactNode } from 'react';
import { Tooltip } from './Tooltip';

interface FieldProps {
  label: string;
  hint?: string;
  helpText?: string;
  error?: string;
  htmlFor?: string;
  children: ReactNode;
}

export function Field({ label, hint, helpText, error, htmlFor, children }: FieldProps) {
  return (
    <div className="field">
      <label className="field-label" htmlFor={htmlFor}>
        {label}
        {helpText && <Tooltip label={helpText} ariaLabel={`Help: ${label}`} />}
      </label>
      {children}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
